import { observer } from 'mobx-react'
import React, { ReactElement, useEffect } from 'react'

import {
   useGetPipelinesForPipelineItem,
   useRecordWisePipelinesStore
} from '@flowwai-frontend/bps-officer-web/common/data-access'
import { API_SUCCESS } from '@flowwai-frontend/shared/api-common'
import { LoadingWrapper } from '@flowwai-frontend/shared/common-components'

interface PropsType {
   pipelineItemId: string
   children: ReactElement
}

const PipelineItemPipelinesAPIController = (
   props: PropsType
): React.ReactElement => {
   const { pipelineItemId } = props

   const recordWisePipelinesStore = useRecordWisePipelinesStore()
   const hasPipelines = recordWisePipelinesStore.hasRecordPipelineIds(
      pipelineItemId
   )

   const pipelinesForPipelineItemAPI = useGetPipelinesForPipelineItem()

   const doNetworkCall = () => {
      pipelinesForPipelineItemAPI.triggerAPI({
         pipelineItemIds: [pipelineItemId]
      })
   }

   useEffect(() => {
      if (hasPipelines) return
      doNetworkCall()
   }, [])

   return (
      <LoadingWrapper
         apiError={pipelinesForPipelineItemAPI.apiError}
         apiStatus={
            hasPipelines ? API_SUCCESS : pipelinesForPipelineItemAPI.apiStatus
         }
         onRetry={doNetworkCall}
      >
         {props.children}
      </LoadingWrapper>
   )
}

export default observer(PipelineItemPipelinesAPIController)
